<template>
  <el-dialog
    center
    width="90%"
    top="0"
    :lock-scroll="true"
    :model-value="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :title="title"
    @closed="closeDialog"
  >
    <div v-html="message" class="dialogMessage"></div>
    <template #footer>
      <div class="dialog-footer flex flex-col gap-1">
        <div>
          <el-button id="AppDialog_proceedAnyway" type="primary" @click="proceedAnyway" class="full-w-button mx-0">
            {{ $t('proceedAnyway') }}
          </el-button>
        </div>
        <div>
          <el-button id="AppDialog_cancelDialog" @click="closeDialog" class="full-w-button mx-0">
            {{ $t('cancel') }}
          </el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  components: {},
  name: 'SkippingCustomValidationDialog',
  emits: ['proceed', 'close'],
})
export default class SkippingCustomValidationDialog extends Vue {
  @Prop({ default: false }) visible!: boolean
  @Prop({ default: '' }) message!: string
  @Prop({ default: 'Custom Validation Warning' }) title!: string

  closeDialog() {
    this.$emit('close')
  }

  proceedAnyway() {
    this.$emit('proceed')
  }
}
</script>
